// invoice http service

import { api } from './api.config'

import request from '@/utils/request'

export default {
  account: {
    info (data) {
      return request({
        url: api.account.info,
        method: 'get',
        data
      })
    },
    // logout (data) {
    //   return request({
    //     url: api.log.logout,
    //     method: 'post',
    //     data
    //   })
    // }
    updateInfo (data) {
      return request({
        url: api.account.updateInfo,
        method: 'post',
        data
      })
    },
    refreshLogin (data) {
      return request({
        url: api.account.refreshLogin,
        method: 'get',
        data
      })
    },
    queryResource (data) {
      return request({
        url: api.account.queryResource,
        method: 'get',
        data
      })
    }
  },
  login: {
    login (data) {
      return request({
        url: api.login.login,
        method: 'post',
        data
      })
    }
    // logout (data) {
    //   return request({
    //     url: api.log.logout,
    //     method: 'post',
    //     data
    //   })
    // }
  },
  reset: {
    inspectPhone (data) {
      return request({
        url: api.reset.inspectPhone,
        method: 'get',
        data,
        xToken: false
      })
    },
    updatePassword (data) {
      return request({
        url: api.reset.updatePassword,
        method: 'post',
        data,
        xToken: false
      })
    },
    getCheckCode (data) {
      return request({
        url: api.reset.getCheckCode,
        method: 'post',
        data
      })
    },
    getCode (data) {
      return request({
        url: api.reset.getCode,
        method: 'post',
        data
      })
    },
    resetPassword (data) {
      return request({
        url: api.reset.resetPassword,
        method: 'post',
        data
      })
    },
    // eslint-disable-next-line no-dupe-keys
    updatePassword (data) {
      return request({
        url: api.reset.updatePassword,
        method: 'post',
        data
      })
    }
  },
  company: {
    getCompanyList (data) {
      return request({
        url: api.company.getCompanyList,
        method: 'post',
        data
      })
    },
    changeCurrentCompany (data) {
      return request({
        url: api.company.changeCurrentCompany,
        method: 'get',
        data
      })
    },
    getCompanyDetail (data, params) {
      return request({
        url: api.company.getCompanyDetail,
        method: 'get',
        data,
        params
      })
    },
    getBanner (data, params) {
      return request({
        url: api.company.getBanner,
        method: 'get',
        data
      })
    },
    getStaffList (data) {
      return request({
        url: api.company.getStaffList,
        method: 'post',
        data
      })
    },
    queryIpConfig (data) {
      return request({
        url: api.company.queryIpConfig,
        method: 'get',
        data
      })
    }
  }
}
